exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 1rem 3rem;\n  height: 7rem; }\n  :host i:first-child {\n    margin-right: .5rem; }\n  :host .name {\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n  :host a {\n    line-height: 2em; }\n  :host .remove {\n    display: none; }\n  :host:hover {\n    background-color: rgba(0, 0, 0, 0.05); }\n    :host:hover .remove {\n      display: -ms-flexbox;\n      display: flex; }\n  :host:not(:last-child) {\n    border-bottom: solid 1px #DCDCDC; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/user-button/user-button.component.scss
// module id = ../../../../../src/app/ui-shared/user-button/user-button.component.scss
// module chunks = main